const en = {
    splash: {
        start: {
            helper: "Press the button to begin",
            button: "Start order"
        },
        banner: {
            title: "Welcome to {ORGANISATION}!",
            content: "Use this self-service kiosk to order your admission ticket(s) quickly and easily."
        }
    },
    catalog: {
        loading: "Loading...",
        tabs: {
            ongoing: "Current",
            all: "All"
        },
        items: {
            select: "Select",
            empty: "No upcoming events!"
        }
    },
    cart: {
        title: "My reservation",
        empty: "There are no tickets in your reservation yet!",
        items: {
            tickets: "Tickets",
            date: "Date",
            time: "Time"
        },
        total: "Total amount",
        buttons: {
            checkout: "Checkout",
            cancel: "Cancel"
        }
    },
    booking: {
        steps: {
            quantity: {
                title: "Ticket quantities"
            },
            upsell: {
                title: "Add-ons for your order"
            },
            plot: {
                title: "Reservation",
                empty: "No booking slots are available.",
                now: "You selected a booking slot for immediate entry.",
                change: "Change"
            }
        },
        buttons: {
            continue: "Continue",
            return: "Back",
            cancel: "Cancel"
        }
    },
    checkout: {
        loading: "Loading...",
        steps: {
            payment: "Complete the payment on the card terminal...",
            acts: {
                payment: "Complete the payment by card or cash...",
                paymentLeft: "You still need to pay {paymentLeft}",
                cancel: "Cancel"
            },
            tickets: "Payment successful! Please take your tickets...",
            tickets_info: "Would you also like to receive a card receipt?",
            receipt: "Please take your receipt...",
            receipt_info: "Your card receipt has been printed.",
            failures: {
                transaction: {
                    title: "The payment was not completed!",
                    description: "You can try the transaction again."
                },
                print: {
                    title: "Tickets and receipt could not be printed!",
                    description: "Ask a staff member to check the printer. Your tickets and card receipt will still be printed afterwards."
                }
            },
            error: "The order could not be placed!"
        },
        buttons: {
            retry: "Try again",
            cancel: "Back",
            next: "Next customer",
            yes: "Yes",
            yes_info: "I want a receipt!",
            no: "No",
            no_info: "No receipt needed!",
            reprint_tickets: "Reprint tickets",
            reprint_tickets_countdown: "Reprint tickets ({seconds}s)"
        }
    },
    errors: {
        audience_not_found: "The audience could not be found.",
        captcha_invalid: "The CAPTCHA is invalid. Reload the page and place the order again.",
        coupon_expired: "This coupon has expired.",
        coupon_invalid: "The coupon code provided is invalid.",
        coupon_product_mismatch: "This coupon cannot be used for this product.",
        coupon_redemptions_exceeded: "This coupon has been fully used.",
        customer_field_invalid: "A form field is filled in incorrectly. Please check your details.",
        customer_field_missing: "A form field is missing. Please check your details.",
        customer_token_invalid: "Customer token is invalid. Please log in again.",
        customer_token_required: "This email address is already registered. Please log in before placing an order.",
        plot_capacity_insufficient: "The booking slot you are trying to order has no capacity left. Please select another slot.",
        plot_not_found: "The booking slot you are trying to order is no longer available.",
        product_max_quantity_exceeded: "The number of tickets exceeds the maximum allowed. Please reduce the quantity.",
        product_min_quantity_exceeded: "The number of tickets is below the minimum required. Please increase the quantity.",
        product_not_found: "The product you are trying to order is no longer available.",
        rebook_invalid: "The rebooking is invalid.",
        rebook_product_mismatch: "The rebooking cannot be used with the specified product.",
        subscription_expired: "The subscription has expired.",
        subscription_inactive: "The subscription is no longer active. Capacity is probably insufficient.",
        subscription_invalid: "The subscription is invalid.",
        subscription_not_found: "The specified subscription could not be found.",
        subscription_product_mismatch: "The subscription does not grant access to this product.",
        subscription_quantity_mismatch: "The subscription does not grant access to these quantities.",
        subscription_redemptions_exceeded: "The subscription has exceeded its maximum usage.",
        subscription_used_today: "The subscription has already been used today.",
        upsell_not_allowed: "This upsell cannot be ordered together with this product.",
        upsell_not_found: "The upsell could not be found."
    },
    printer: {
        title: "A printer error occurred!",
        reload: "Try again",
        errors: {
            paper_empty: "Paper is running low.",
            cover_open: "The cover is open.",
            device_offline: "Unable to connect.",
            device_malfunction: "A general error occurred."
        }
    }
};

export default en;
